import { SalesProcessing } from 'components/SalesProcessing';
import { Page } from 'layouts/Page';
import { ENavigateNames } from '../../routes/constants';

export const SalesProcessingPage = () => {
	return (
		<Page title={`${ENavigateNames.SALES_PROCESSING}– EAS Control Center`}>
			<SalesProcessing />
		</Page>
	);
};
